export default __webpack_public_path__ + "static/media/createfile-shopping-bag-sm-red.ba7b2355.svg";